// tslint:disable-next-line:no-implicit-dependencies
import * as Aria from 'aria';

// This code uses CommonJS syntax because the 'real' module name differs from the typings.
export const aria: typeof Aria = require(
  '@ms/aria-private'
);
